import { Injectable } from '@angular/core';
import { PAGES_CONFIG, PAGE_SIDE_MENU_CONFIG } from '../configs/pages.config';
import { Storage } from '@ionic/storage';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { EnvService } from './env.service';
import { App } from 'ionic-angular';

interface IMenu {
  title:string;
  pageClass:string;
  isShow?: boolean;
  isLogout?: boolean;
  isCacheClear?: boolean;
}
interface IMenuGroup {
  groupTitle: string;
  isShow:boolean;
  isTopMenu?: boolean,
  list:IMenu[]
};

// 必ず表示させるページのみ初期設定はtrueとしておく
const MENU_LIST:IMenuGroup[] = [
  {
    groupTitle:'',
    isTopMenu: true,
    isShow: true,
    list: [
      {title: 'トップ', pageClass:PAGES_CONFIG.TOP_SENSOR_DASHBOARD},
    ]
  },
  {
    groupTitle:'見る',
    isShow: false,
    list: [
      // {title: '睡眠状況の確認', pageClass: PAGES_CONFIG.SLEEP_STATE_TODAY_LIST},
    ]
  },
  {
    groupTitle:'記録する',
    isShow: true,
    list: [
      // {title: '睡眠時間の記録', pageClass: PAGES_CONFIG.SLEEP_TIME_VIEWER},
    ]
  },
  {
  groupTitle:'ログの確認',
  isShow: true,
  list: [
    {title: '介護記録システム連携ログ', pageClass: PAGES_CONFIG.ACTION_SYNC_CARE_SYSTEM_LOGS},
    {title: 'センサー・ナースコール受信ログ', pageClass:PAGES_CONFIG.ACTION_SLEEP_SENSOR_DATA_LOGS},
    { title: 'アプリ操作ログ', pageClass: PAGES_CONFIG.ACTION_LOGS },
  ]
  },
  {
    groupTitle:'各種設定・管理',
    isShow: true,
    list: [
      { title: 'マスター管理', pageClass:PAGES_CONFIG.MASTER},
      // {title: 'センサー管理', pageClass:PAGES_CONFIG.SETTING_SENSOR,},
      {title: 'センサー・ナースコール管理', pageClass:PAGES_CONFIG.SETTING_SLEEP_DEVICE},
      {title: 'お部屋(ベッド)の管理', pageClass:PAGES_CONFIG.SETTING_ROOM},
      // {title: '介護記録システム連携設定', pageClass:PAGES_CONFIG.SETTING_SYNC_CARE_SYSTEM},
      {title: 'ログインパスワードの変更', pageClass: PAGES_CONFIG.CHANGE_PASSWORD},
    //  {title: 'デバッグログの表示', pageClass:'DebugLogPage', default: false, isShow: false},
    //  {title: '設定', pageClass:'settingPage', default: false, isShow: false},
    ]
  },
  {
    groupTitle: '開発者メニュー',
    isShow: false,
    list: [
      { title: '記録連携データの作成', pageClass: PAGES_CONFIG.DEBUG_DEMO_DETA_PAGE },
      { title: '【デバック用】センサー受信データ確認', pageClass: PAGES_CONFIG.DEBUG_SENSOR },
      { title: '【ナースコール】お部屋（ベッド）の確認', pageClass: PAGES_CONFIG.SETTING_NURSECALL_DEVICE },
      { title: '【ナースコール】既存利用者との紐付け確認', pageClass: PAGES_CONFIG.SETTING_SYNC_NURSE_CALL_PATIENT },
      { title: '【ナースコール】直近の連携利用者確認', pageClass: PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_LOG },
      { title: '【ナースコール】利用者情報の差分の確認', pageClass: PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_DIFF },
    ]
  },
  {
    groupTitle:'その他',
    isShow: true,
    list: [
      // {title: 'お知らせ', pageClass:PAGES_CONFIG.MASTER_NEWS_LIST},
      {title: 'システムのバージョン', pageClass:PAGES_CONFIG.APPLICATION},
      {title: 'ログアウト', pageClass:null, isLogout: true},
    ]
  }
];


@Injectable()
export class SideMenuService {

  // - 表示可能なメニューのリスト: ログインAPIで取得可能
  menuList:IMenuGroup[] = [];

  private clickCount = 0;
  private lastClickTime = 0;

  constructor(
    private storage: Storage,
    private envService: EnvService,
    private app: App,
  ) {
    this.init();
  }

  /**
   * 表示するサイドメニューのリストを初期化する
   */
  init(){
    this.setShowMenuList();
  }

  /**
   * 開発者メニュー表示の為のクリックカウント
   */
  incrementClickCount() {
    const currentTime = new Date().getTime();
    if (currentTime - this.lastClickTime < 1000) { // 1秒以内の連続クリックをチェック
      this.clickCount++;
    } else {
      this.clickCount = 1; // リセット
    }
    this.lastClickTime = currentTime;

    // クリックカウントで開発者メニューを表示する
    if (this.clickCount >= 3) {
      let showMenuList: string[] = [];
      showMenuList.push(PAGES_CONFIG.DEBUG_DEMO_DETA_PAGE);  // 記録連携データの作成
      showMenuList.push(PAGES_CONFIG.DEBUG_SENSOR);  // 【デバック用】センサー受信データ確認
      showMenuList.push(PAGES_CONFIG.SETTING_NURSECALL_DEVICE);  // 【ナースコール】お部屋（ベッド）の確認
      showMenuList.push(PAGES_CONFIG.SETTING_SYNC_NURSE_CALL_PATIENT);  // 【ナースコール】既存利用者との紐付け確認
      showMenuList.push(PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_LOG);  // 【ナースコール】直近の連携利用者確認
      showMenuList.push(PAGES_CONFIG.NURSE_CALL_PATIENT_SYNC_DIFF);  // 【ナースコール】利用者情報の差分の確認

      // 開発者メニューを表示する
      this.menuList = this.menuList.map(menuGroup => {
        if (menuGroup.groupTitle === '開発者メニュー') {
          menuGroup.isShow = true;
          menuGroup.list = menuGroup.list.map((menu) => {
            menu.isShow = (showMenuList.indexOf(menu.pageClass) >= 0);
            return menu;
          });
        }
        return menuGroup;
      });
    }
  }

  /**
   * 表示するページクラスのリスト
   */
  async setShowMenuList(menuType = "", menus: {[pageKey in string]: boolean} = {}) {
    let showMenuList: string[] = [];
    if (menuType === "") {
      showMenuList = [];
    } else {
      // CDC バイタリーの場合
      if (menuType === 'VITALY') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.VITALY;
      // TODO: CDC センサー連携の場合

      // TODO: CDC 見守りViewerの場合

      // ワイズマン バイタル連携の場合
      } else if (menuType === 'WSP') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.WSP_VITAL_MENU;
      // ワイズマン センサー連携の場合
      } else if (menuType === 'WSP_SENSOR') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.WSP_SENSOR_MENU;
      // ワイズマン ナースコール連携の場合
      } else if (menuType === 'WSP_NURSECALL') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.WSP_NURSECALL_MENU;
      // ワイズマン センサー＆ナースコール連携の場合
      } else if (menuType === 'WSP_SENSOR_NURSECALL') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.WSP_SENSOR_NURSECALL;
      // ケア樹 バイタル連携の場合
      } else if (menuType === 'GCT_VITALY') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.GCT_VITAL_MENU;
      // SOMPO様 見守りViewer＆バイタル計測
      } else if (menuType === 'SOMPO_MENU') {
        showMenuList = PAGE_SIDE_MENU_CONFIG.SOMPO_MENU;
        // TODO: 両方の場合
      } else {
        showMenuList = PAGE_SIDE_MENU_CONFIG.DEFAULT;
      }

      // DB管理側でメニューの出し分け表示を可能にする
      Object.keys(menus).forEach(pageKey => {
        // 開発者メニューは隠しコマンドで表示する
        if (menus[pageKey] && PAGE_SIDE_MENU_CONFIG.DEVELOPER_MENU.indexOf(pageKey) === -1) {
          showMenuList.push(pageKey);
        } else {
          // falseの場合は、表示リストに入っていても除外する
          showMenuList = showMenuList.filter(showPageKey => showPageKey !== pageKey);
        }
      });
    }

    let _user = await this.storage.get(COOKIES_CONFIG.LOGIN_USER)
    let loginUser;
    try {
      loginUser = JSON.parse(_user);
    } catch (e) {
    }
    console.log(loginUser);

    // 本番環境では表示しないメニューを強制的に非表示にする
    if (this.envService.isProd()) {
      showMenuList = showMenuList.filter(menu => {
        // マスター管理は、開発環境のみ表示
        return menu !== PAGES_CONFIG.MASTER;
      });
    }

    // 特定のIDのみマスター情報を表示する
    //   - 667335d176ec84617bfdcae0: 【テスト】eCityLabo 設定検証用ライセンス TS7FSC7RXKR
    //   - 666a8567f9b86a61f9a0a773: 【デモ】愛総合福祉会 SS8FLC8RBWY
    if (loginUser && "667335d176ec84617bfdcae0" === loginUser.contractGroupId || loginUser && "666a8567f9b86a61f9a0a773" === loginUser.contractGroupId) {
      showMenuList.push(PAGES_CONFIG.MASTER);
    }

    // 特定のIDのみ表示可能にする
    // - テスト環境
    //   - 61f92c075e87040a9b2538a5: 絆Core(100810081) ITS開発環境(Azure)
    //   - 620184d5b99ecd08322eead3: 絆Core(100710071) ITS検証環境(Azure)
    //   - 620184e8b99ecd78cf771842: 絆Core(190919091) レスポンス検証環境
    //   - 62255822b99ecd74d73ca186: 絆Core(200120011) 総合テスト環境
    // - 本番環境
    //   - 62255cc9b99ecd74da7cd315: 絆Core(700170011) デモ環境
    //   - 622e63d4b99ecd6f5e088a02: 絆Core(613410001) 本番用UCDYK6134
    // 開発版の場合は、メニュー表示
    const KIZUNACORE_DEV_ID_LIST = [
      "61f92c075e87040a9b2538a5", "620184d5b99ecd08322eead3", "620184e8b99ecd78cf771842", "62255822b99ecd74d73ca186",
      "62255cc9b99ecd74da7cd315", "622e63d4b99ecd6f5e088a02",
    ];
    if (loginUser && KIZUNACORE_DEV_ID_LIST.find(id => id === loginUser.contractGroupId)) {
      // showMenuList.push(PAGES_CONFIG.DEBUG_DEMO_DETA_PAGE);
    }

    this.menuList = MENU_LIST.map((menuGroup) => {
      // 1件でも表示メニューがあれば、グループの部分を表示する
      let isShowMenuGroup = false;
      menuGroup.list = menuGroup.list.map((menu) => {
        menu.isShow = (showMenuList.indexOf(menu.pageClass) >= 0);
        if (menu.isShow) isShowMenuGroup = true;
        return menu;
      });
      menuGroup.isShow = isShowMenuGroup;

      if (menuGroup.isTopMenu) {
        if (loginUser && loginUser.contractName) {
          menuGroup.groupTitle = loginUser.contractName;
        }
      }
      return menuGroup;
    });
  }

  navigateToPage(page: any) {
    const navCtrl = this.app.getActiveNav();
    navCtrl.setRoot(PAGES_CONFIG.TOP_SENSOR_DASHBOARD);
    if (page !== PAGES_CONFIG.TOP_SENSOR_DASHBOARD) {
      navCtrl.push(page);
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/side.menu.service.ts